module.exports = __webpack_public_path__ + "static/img/logo.16cb7ddd.png";